import * as React from 'react';

import { EmptyField, TextField } from '../../../../../../components/Field/common';
import { useOfferContext } from '../../../../../../utils/offerContext';

export const HouseCountFieldContainer: React.FC = () => {
  const { newbuilding, published } = useOfferContext();
  const houseCount = newbuilding?.houseCount;

  if (!houseCount) {
    return <EmptyField published={published} />;
  }

  return <TextField published={published}>{houseCount}</TextField>;
};
